import styled, { keyframes } from 'styled-components';

import { CuiTheme } from '@crehana/ui';

const popAnimation = keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`;

const bottomInAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(400px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const opacityAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const CardsContainer = styled.div`
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    width: 590px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    width: 740px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    flex-wrap: nowrap;
    width: 100%;
  }
`;

export const StyledCard = styled.div<{ index: number }>`
  min-height: 112px;
  max-width: 280px;
  animation: ${popAnimation} 500ms ease;
  animation-delay: ${({ index }) => 300 + 150 * index}ms;
  animation-fill-mode: forwards;
  transform: scale(0);
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    width: 280px;
    min-height: 136px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    width: 220px;
    flex-shrink: 1;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    width: 240px;
  }
`;

export const StyledSubtitle = styled.p`
  opacity: 0;
  animation: ${opacityAnimation} 500ms ease;
  animation-delay: 100ms;
  animation-fill-mode: forwards;
  max-width: 680px;
`;

export const StyledH4 = styled.p`
  opacity: 0;
  animation: ${opacityAnimation} 500ms ease;
  animation-delay: 100ms;
  animation-fill-mode: forwards;
`;

export const StyledH2 = styled.h2`
  max-width: 700px;
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-width: 920px;
  }
`;

export const StyledImage = styled.div`
  height: 160px;
  width: 120vw;

  left: -10vw;
  bottom: 0;
  right: 0;

  transform: translateY(400px);
  animation: ${bottomInAnimation} 300ms ease;
  animation-delay: 600ms;
  animation-fill-mode: forwards;

  ::after {
    content: '';
    width: 100%;
    height: 60px;
    background: linear-gradient(
      180deg,
      rgba(247, 248, 250, 0) 0%,
      rgba(247, 248, 250, 0.536075) 42.15%,
      #f7f8fa 78.63%
    );
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }

  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    height: 320px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    width: 90%;
    left: 0;
    height: 300px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-width: 1366px;
    height: 340px;
  }
`;
